import Notification from '@/components/Notification';
import externalEditorWarnPng from '@/assets/img/externalEditorWarnPng.png';
import styles from './index.module.scss';

interface IProps {
    setIsTocUpdateVis: (val: boolean) => void;
}

function PullCardTip(props: IProps) {
    const {setIsTocUpdateVis} = props;

    const handleClose = () => {
        setIsTocUpdateVis(false);
    };

    return (
        <div className={styles.notification}>
            <Notification
                type={'warning'}
                content={<div>
                    <img src={externalEditorWarnPng} alt="" className={styles.remindPng} />
                    <span className={styles.textSty}>
                        你所编辑的内容需要“更新”后其他用户才可阅读，请在编辑完成后点击“更新”按钮。
                    </span>
                </div>}
                onClose={handleClose}
            />
        </div>
    );
}

export default PullCardTip;
